const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship La Dosis Positiva',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Transmisión en vivo: Jueves 2:00 PM por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con bienestar, productividad y crecimiento personal',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de bienestar, salud, lifestyle y emprendimiento que buscan conectar con una audiencia proactiva.',
    duration: 'Mensual',
    buttonText: 'Patrocinar La Dosis Positiva',
    highlightedTitle: 'Energía Positiva Multiplataforma',
    highlightedContent: [
      'Tu marca viaja con el carisma de Yanira Bocaranda.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Temas de crecimiento personal, bienestar y actualidad en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Salud, Tecnología, Emprendimiento o Moda',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas especializadas que buscan relevancia temática y afinidad con el contenido.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad de Nicho',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con bienestar, innovación o lifestyle.',
      'Ideal para posicionar productos en contextos de alta afinidad.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de puntos de venta',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Emprendedores, coaches y voceros que buscan visibilidad con una audiencia consciente.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Este formato les garantiza la proyección de sus videos promocionales.',
      'Mención de puntos de venta y propuesta con respaldo visual en pantalla.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de La Dosis Positiva y TNO Digest',
      'Contenido adaptado a bienestar, productividad y lifestyle',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para anuncios, lanzamientos o reforzar una campaña.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula de Bienestar / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: tips de bienestar, lanzamiento o promoción',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de bienestar, lanzamientos de producto o mensajes de marca positiva.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de La Dosis Positiva.',
      'Formato breve y memorable para máxima recordación.',
      'Ideal para campañas de corto plazo y alto impacto.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  // --- UGC & Wellness (Contenido creado por el usuario) ---
  {
    title: 'UGC Lifestyle Video',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video dinámico estilo "Daily Vlog" o "Tutorial Práctico"',
      'Demostración real del producto en una rutina de bienestar',
      'Narrativa humana, sin filtros, enfocada en la solución',
      'Publicación del video en TNO y en La Dosis Positiva',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Productos de consumo masivo, salud, tecnología personal y servicios de bienestar.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba Social Directa',
    highlightedContent: [
      'El contenido UGC genera hasta 6.9 veces más impacto que la publicidad tradicional.',
      'Posicionamos tu marca como la recomendación de un aliado, no como un anuncio.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
